import React, {Component} from 'react';
import {Grid, Header, Image, Responsive, Segment} from "semantic-ui-react";

export default class Error extends Component {

    render() {

        return (
            <div>
                <Responsive minWidth={376}>
                    <Grid verticalAlign='middle' columns={2} centered>
                        <Grid.Column>
                            <Message />
                        </Grid.Column>
                    </Grid>
                </Responsive>
                <Responsive maxWidth={375}>
                    <Grid verticalAlign='middle' columns={1} centered padded>
                        <Grid.Column width={16}>
                            <Message />
                        </Grid.Column>
                    </Grid>
                </Responsive>
            </div>
        )

    }

}

const Message = () => (
    <Segment raised padded className={'login-pane'}>
        <Image src={'/img/favicon.png'} size={'small'} centered />
        <Header as='h2' icon textAlign='center'>
            <Header.Content>
                This is not the pepper you are looking for.
            </Header.Content>
        </Header>
    </Segment>
);
